import React from 'react'

export default function App() {
  return <h2>hello React</h2>
}
